import { defineMessages, useIntl } from 'react-intl';
import React, { useCallback, useMemo } from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';

import AdvancedHotkey from './component';

export const messages = defineMessages({
  name: {
    description: 'navigationHotkeys.ShipmentsBatchesPage',
    defaultMessage: 'Shipments > Batches',
    id: '8ugF2t',
  },
});

export const hotkey = ['g', 'b'];
export const barcodeContent = '+VACSQAC75M5J=';

const GotoShipmentsBatchesPage = ({ children }) => {
  const intl = useIntl();
  const history = useHistory();
  const handler = useCallback(() => history.push('/shipments/batches'), [history]);
  const hotkeyMetadata = useMemo(
    () => ({
      barcode: barcodeContent,
      displayHotkeyStrings: ['gb'],
      hotkey,
      handler,
      name: intl.formatMessage(messages.name),
      legacyCategory: 'navigation',
      isGlobal: true,
    }),
    [intl, handler],
  );

  return <AdvancedHotkey hotkey={hotkeyMetadata}>{children}</AdvancedHotkey>;
};

GotoShipmentsBatchesPage.propTypes = {
  children: PropTypes.node.isRequired,
};

export default GotoShipmentsBatchesPage;
